import { createCustomEase } from 'scripts/lib/gsap/customEase';

export namespace Easings {
    export const customEaseInOut = createCustomEase('customEaseInOut', '.57,0,.43,1');
    export const customEaseIn = createCustomEase('customEaseIn', '.57,0,.83,.83');
    export const customEase = createCustomEase('customEase', '.17,.17,.43,1');

    export const chartEaseIn = createCustomEase('chart-ease-in', '0.17, 0.17, 0.43, 1.00');
    export const chartEaseOut = createCustomEase('chart-ease-out', '0.57, 0.00, 0.83, 0.83');
    export const chartOpacity = createCustomEase('chart-opacity', '0.57, 0.00, 0.43, 1.00');
}
